import { AutoPayFormErrorJSON } from '../models/auto-pay-form';

export const autoPayFormErrors: AutoPayFormErrorJSON = {
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
